import { Enum, EnumType } from 'ts-jenum';

/**
 * Defines keys as they are shown to the user (not the code of the key)
 */
export class Key {
   static readonly Alt = 'Alt';
   static readonly Ctrl = 'Ctrl';
   static readonly Meta = 'Meta';
   static readonly Shift = 'Shift';
   static readonly Digit1 = '1';
   static readonly Digit2 = '2';
   static readonly Digit3 = '3';
   static readonly Digit4 = '4';
   static readonly Digit5 = '5';
   static readonly Digit6 = '6';
   static readonly Digit7 = '7';
   static readonly Digit8 = '8';
   static readonly Digit9 = '9';
   static readonly Digit0 = '0';
   static readonly KeyA = 'A';
   static readonly KeyB = 'B';
   static readonly KeyC = 'C';
   static readonly KeyD = 'D';
   static readonly KeyE = 'E';
   static readonly KeyF = 'F';
   static readonly KeyG = 'G';
   static readonly KeyH = 'H';
   static readonly KeyI = 'I';
   static readonly KeyJ = 'J';
   static readonly KeyK = 'K';
   static readonly KeyL = 'L';
   static readonly KeyM = 'M';
   static readonly KeyN = 'N';
   static readonly KeyO = 'O';
   static readonly KeyP = 'P';
   static readonly KeyQ = 'Q';
   static readonly KeyR = 'R';
   static readonly KeyS = 'S';
   static readonly KeyT = 'T';
   static readonly KeyU = 'U';
   static readonly KeyV = 'V';
   static readonly KeyW = 'W';
   static readonly KeyX = 'X';
   static readonly KeyY = 'Y';
   static readonly KeyZ = 'Z';
   static readonly Enter = 'Enter';
   static readonly NumpadEnter = 'Enter (Numpad)';
   static readonly NumpadDivide = 'Divide (Numpad)';
   static readonly NumpadMultiply = 'Multiply (Numpad)';
   static readonly NumpadAdd = 'Add (Numpad)';
   static readonly NumpadSubtract = 'Subtract (Numpad)';
   static readonly NumpadDecimal = 'Decimal (Numpad)';
   static readonly Numpad0 = '0 (Numpad)';
   static readonly Numpad1 = '1 (Numpad)';
   static readonly Numpad2 = '2 (Numpad)';
   static readonly Numpad3 = '3 (Numpad)';
   static readonly Numpad4 = '4 (Numpad)';
   static readonly Numpad5 = '5 (Numpad)';
   static readonly Numpad6 = '6 (Numpad)';
   static readonly Numpad7 = '7 (Numpad)';
   static readonly Numpad8 = '8 (Numpad)';
   static readonly Numpad9 = '9 (Numpad)';
   static readonly ArrowUp = 'Up';
   static readonly ArrowDown = 'Down';
   static readonly ArrowLeft = 'Left';
   static readonly ArrowRight = 'Right';
   static readonly PageDown = 'PageDown';
   static readonly PageUp = 'PageUp';
   static readonly F1 = 'F1';
   static readonly F2 = 'F2';
   static readonly F3 = 'F3';
   static readonly F4 = 'F4';
   static readonly F5 = 'F5';
   static readonly F6 = 'F6';
   static readonly F7 = 'F7';
   static readonly F8 = 'F8';
   static readonly F9 = 'F9';
   static readonly F10 = 'F10';
   static readonly F11 = 'F11';
   static readonly F12 = 'F12';
   static readonly ScrollLock = 'ScrollLock';
   static readonly Pause = 'Pause';
   static readonly AudioVolumeMute = 'AudioVolumeMute';
   static readonly MediaStop = 'MediaStop';
   static readonly MediaTrackPrevious = 'MediaTrackPrevious';
   static readonly MediaTrackNext = 'MediaTrackNext';
   static readonly MediaPlayPause = 'MediaPlayPause';
   static readonly MediaSelect = 'MediaSelect';
   static readonly BrowserBack = 'BrowserBack';
   static readonly BrowserForward = 'BrowserForward';
   static readonly BrowserStop = 'BrowserStop';
   static readonly BrowserRefresh = 'BrowserRefresh';
   static readonly LaunchMail = 'LaunchMail';
   static readonly LaunchApp1 = 'LaunchApp1';
   static readonly LaunchApp2 = 'LaunchApp2';
   static readonly Escape = 'Escape';
   static readonly Tab = 'Tab';
   static readonly CapsLock = 'CapsLock';
   static readonly Backspace = 'Backspace';
   static readonly Delete = 'Delete';
   static readonly End = 'End';
   static readonly Home = 'Home';
   static readonly AltGr = 'AltGr';
   static readonly ContextMenu = 'ContextMenu';
   static readonly Backquote = '`';
   static readonly Backslash = '\\';
   static readonly Slash = '/';
   static readonly Pound = '#';
   static readonly Plus = '+';
   static readonly Star = '*';
   static readonly Minus = '-';
   static readonly LowerThan = '<';
   static readonly KeyAe = 'Ä';
   static readonly KeyOe = 'Ö';
   static readonly KeyUe = 'Ü';
   static readonly Dot = '.';
   static readonly Comma = ',';
   static readonly Caret = '^';
   static readonly Eszet = 'ß';
   static readonly Dead = '´';
}
